import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Section = styled.div`
  padding-top: 8px;
`;

export const Text = styled.p`
  font-size: 12px;
  line-height: 1.5;
  color: ${ColorPalette.HEX.DimGray};
  overflow-wrap: break-word;

  & > strong {
    font-weight: 600;
  }
`;

export const Price = styled.span`
  font-size: 12px;
  line-height: 1.33;
  letter-spacing: -0.2px;
  color: ${ColorPalette.HEX.DimGray};
  margin-bottom: 4px;
  margin-left: 10px;
  &::before {
    content: '';
    display: inline-block;
    width: 4px;
    height: 4px;
    -moz-border-radius: 7.5px;
    -webkit-border-radius: 7.5px;
    border-radius: 7.5px;
    margin-right: 3px;
    margin-bottom: 3px;
    background-color: ${ColorPalette.HEX.DimGray};
  }
`;
